import BaseModel from "../../../core/components/input-widget/BaseModel";

export default class AllocatePaymentItemModel extends BaseModel {
  uuid = null;
  invoice_uuid = null;
  invoice = null;
  amount = null;
  outstanding_amount = null;

  static TRANSLATABLE_FIELDS = [];

  rules = {
    invoice_uuid: 'required',
    amount: 'required|min_value:0.1',
  };

  attributeLabels = {
  };

  attributeHints = {
  }

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }
}

